import { ICreateProjetoDisciplinaUseCase } from "../../../presentation/useCases/create/create_projeto_disciplina_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";

export class CreateProjetoDisciplinaUseCase implements ICreateProjetoDisciplinaUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async createProjetoDisciplina(
    idProjeto: number,
    idChecklist: number | null,
    tipo: string | null,
    descricao: string | null,
    idFuncionario: number | null,
    idFornecedor: number | null,
    descResponsavel: string | null,
    datainicioPrevisto: Date | null,
    datainicioReal: Date | null,
    datafimPrevisto: Date | null,
    datafimReal: Date | null,
    dataDisciplina: Date | null,
    revisao: string | null,
    plantas: string | null,
    local1: string | null,
    local2: string | null,
    local3: string | null,
    local4: string | null,
    local5: string | null,
    local6: string | null,
    subdiciplina: boolean | null,
    idDisciplinaPai: number | null,
    ultimaRevisao: boolean | null,
    idUsuario: number | null,
    idCliente: number | null,
    nCopia1: string | null,
    nCopia2: string | null,
    nCopia3: string | null,
    nCopia4: string | null,
    nCopia5: string | null,
    nCopia6: string | null,
  ): Promise<number> {
    const response = await this.repository.createProjetoDisciplina(
      idProjeto,
      idChecklist,
      tipo,
      descricao,
      idFuncionario,
      idFornecedor,
      descResponsavel,
      datainicioPrevisto,
      datainicioReal,
      datafimPrevisto,
      datafimReal,
      dataDisciplina,
      revisao,
      plantas,
      local1,
      local2,
      local3,
      local4,
      local5,
      local6,
      subdiciplina,
      idDisciplinaPai,
      ultimaRevisao,
      idUsuario,
      idCliente,
      nCopia1,
      nCopia2,
      nCopia3,
      nCopia4,
      nCopia5,
      nCopia6,
    );
    return response.idDisciplina;
  }
}
